import { Ref } from 'vue';
import { HekateDisplayForm } from 'www-shared';
import { FormSubmitResolution } from '../../../../model/HekateFormSubmission';
import AntiSpamUtil from '../../../util/AntiSpamUtil';

export default class FormSubmitResolutionProvider {
  public static async resolve({
    formDefinition,
    successMessageHtml,
  }: {
    formDefinition: Ref<HekateDisplayForm | null>,
    successMessageHtml: Ref<string>,
  }): Promise<FormSubmitResolution | null> {
    if (!formDefinition.value) return null;

    const data: { [key: string]: string | boolean | number } = {};
    formDefinition.value.displayFields.forEach((field) => {
      if (field.dataType === 'none') {
        return;
      }
      data[field.htmlName] = field.val;
    });

    const body = JSON.stringify({
      ...data,
    });

    // eslint-disable-next-line no-bitwise
    const nounce = Math.round(Math.random() * (1 << 30)).toString(16);
    const url = `/api/fb/submitFormResolution?nounce=${nounce}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...await AntiSpamUtil.commonFetchHeaders(),
      },
      body,
    });
    const json = await response.json();

    return {
      formId: formDefinition.value.id,
      successActions: json.successActions,
      successMessageHtml,
    };
  }
}
